import "../styles/upgradeSheet.css";
import { fmtDuration } from "../format";
import { icon } from "../iconsKit";
import { fmtCompact } from "../kit";
import { resourceIconUrl } from "../portraits";

/**
 * The upgrade sheet's small parts (UI pass 2026-10-21), shared by the tower, Fortress and pet sheets: the stat chips,
 * the next level as one row (Lv 1 → Lv 2, what it adds, the timer), the button with its gold on it, and the gold pill
 * for the head. Strings only.
 */

const goldImg = (px: number) => `<img class="us-gold" decoding="sync" src="${resourceIconUrl("gold")}" alt="gold" style="width:${px}px;height:${px}px">`;

/** "Range 2.5 · Damage 10 · 2.0 shots/s" as chips (the label small, the number big where there is one). */
export function statChipsHtml(line: string, extra: readonly string[] = []): string {
  const chip = (part: string): string => {
    const m = /^([A-Za-z][A-Za-z ]*?)\s+([+−-]?[\d.,×%]+.*)$/.exec(part.trim());
    if (m) return `<span class="us-chip"><small>${m[1]}</small><b>${m[2]}</b></span>`;
    const n = /^([\d.,]+)\s+(.+)$/.exec(part.trim());
    return n ? `<span class="us-chip"><b>${n[1]}</b><small>${n[2]}</small></span>` : `<span class="us-chip"><b>${part.trim()}</b></span>`;
  };
  return `<div class="stats us-stats">${[...line.split(" · "), ...extra].filter((x) => x.trim()).map(chip).join("")}</div>`;
}

/** The next level in a row: "Lv 1 → Lv 2", what it adds (optional) and the timer (seconds; 0 leaves it out). */
export function nextRowHtml(from: number, to: number, gain: string, seconds: number, secondary = false): string {
  return `<div class="next us-next${secondary ? " sec" : ""}"><span class="us-lv">Lv ${from}</span><span class="us-arr" aria-hidden="true">${icon("chev", 16)}</span><span class="us-lv to">Lv ${to}</span>`
    + `${gain ? `<span class="us-gain">${gain}</span>` : ""}${seconds > 0 ? `<span class="us-time">${icon("clock", 13)}${fmtDuration(seconds)}</span>` : ""}</div>`;
}

/**
 * UPGRADE / QUEUE with its gold on it; short of gold the gold turns red and the button dims, but it still takes the
 * tap: it opens "Not enough gold" with GET GOLD (owner 2026-10-23, getGold.ts).
 */
export function upgradeBtnHtml(kind: "upgrade" | "queue", cost: number, affordable: boolean): string {
  const cls = kind === "upgrade" ? "upgrade" : "queuego";
  const label = kind === "upgrade" ? "UPGRADE" : `${icon("clock", 18)} QUEUE`;
  return `<button class="btn blue disp ${cls} us-go${affordable ? "" : " shortgold"}"${affordable ? "" : ` aria-disabled="true"`}><span class="us-gl">${label}</span><span class="us-cost${affordable ? "" : " short"}">${goldImg(22)}${fmtCompact(cost)}</span></button>`;
}

/** The head's gold, the currency every upgrade here spends. */
export function goldPillHtml(gold: number): string {
  return `<div class="pill us-goldpill"><div class="ic img">${goldImg(22)}</div><span>${fmtCompact(gold)}</span></div>`;
}
